import { AUDITLOG_BASE_URL, LIVE_USERS, SYSTEMAUDIT } from '../../utils/constants'

export interface ITimeFilter {
    startDay: string
    startHour: string
    endDay: string
    endHour: string
    perPage?: number
    page?: number
    sortOrder?: string
    sortBy?: string
}

export interface IFilterBy {
    filter: string
    elements: string[]
}

export interface IBody {
    filters?: IFilterBy[]
}

export interface ISystemAuditReportRequest extends ITimeFilter {
    filterByStatusCodeStatus?: string
    filterByLiveAuthor?: string
    filterByHTTPVerb?: string
    quickSearch?: string
}

export const getSystemAuditLogs = async (params?: ISystemAuditReportRequest): Promise<ISystemAuditReport> => {
    const qs = new URLSearchParams({
        limit: params.perPage.toString() ?? '',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        sortOrder: params.sortOrder ?? '',
        sortBy: params.sortBy ?? '',
        filterByStatusCodeStatus: params.filterByStatusCodeStatus ?? '',
        filterByLiveAuthor: params.filterByLiveAuthor ?? '',
        filterByHttpVerb: params.filterByHTTPVerb ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${AUDITLOG_BASE_URL}${SYSTEMAUDIT}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
        // body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getAuthors = async (): Promise<string[]> => {
    return fetch(`${AUDITLOG_BASE_URL}${LIVE_USERS}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const exportSystemAuditLogsJson = async (params?: ISystemAuditReportRequest): Promise<void | ISystemAudit> => {
    const qs = new URLSearchParams({
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        filterByStatusCodeStatus: params.filterByStatusCodeStatus ?? '',
        filterByLiveAuthor: params.filterByLiveAuthor ?? '',
        filterByHttpVerb: params.filterByHTTPVerb ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${AUDITLOG_BASE_URL}${SYSTEMAUDIT}/JSON/?${qs}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(response => response.blob())
        .then(blob => {
            try {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                const time = new Date()
                link.href = url

                link.setAttribute(
                    'download',
                    `${params.startDay} ${params.startDay} - ${params.endDay} ${params.endHour}.json`
                )

                document.body.appendChild(link)

                link.click()

                link.parentNode.removeChild(link)
            } catch (err) {
                console.log(err)
            }
        })
}

export const exportSystemAuditLogsCSV = async (params?: ISystemAuditReportRequest): Promise<void | ISystemAudit> => {
    const qs = new URLSearchParams({
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        filterByStatusCodeStatus: params.filterByStatusCodeStatus ?? '',
        filterByLiveAuthor: params.filterByLiveAuthor ?? '',
        filterByHttpVerb: params.filterByHTTPVerb ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${AUDITLOG_BASE_URL}${SYSTEMAUDIT}/CSV/?${qs}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(response => response.blob())
        .then(blob => {
            try {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'download',
                    `${params.startDay} ${params.startDay} - ${params.endDay} ${params.endHour}.csv`
                )

                document.body.appendChild(link)

                link.click()

                link.parentNode.removeChild(link)
            } catch (err) {
                console.log(err)
            }
        })
}

export const exportSystemAuditLogsPDF = async (params?: ISystemAuditReportRequest): Promise<void | ISystemAudit> => {
    const qs = new URLSearchParams({
        startDay: params?.startDay?.toString() ?? '',
        startHour: params.startHour ?? '',
        endDay: params?.endDay ?? '',
        endHour: params?.endHour ?? '',
        filterByStatusCodeStatus: params.filterByStatusCodeStatus ?? '',
        filterByLiveAuthor: params.filterByLiveAuthor ?? '',
        filterByHttpVerb: params.filterByHTTPVerb ?? '',
        quickSearch: params?.quickSearch ?? ''
    }).toString()

    return fetch(`${AUDITLOG_BASE_URL}${SYSTEMAUDIT}/CSV/?${qs}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(response => response.blob())
        .then(blob => {
            try {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'download',
                    `${params.startDay} ${params.startDay} - ${params.endDay} ${params.endHour}.pdf`
                )

                document.body.appendChild(link)

                link.click()

                link.parentNode.removeChild(link)
            } catch (err) {
                console.log(err)
            }
        })
}
